import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';

import { commonActions, departmentActions } from '../../_actions';

import SubCategoryEnhancedTable from './SubCategoryEnhancedTable';
import SubCategoryFormComponent from './SubCategoryFormComponent';
import CostUnitEnhancedTable from './CostUnitEnhancedTable';
import CostUnitFormComponent from './CostUnitFormComponent';
import SubCategoryEnhancedTableTW from './SubCategoryEnhancedTableTW';
import SubCategoryFormComponentTW from './SubCategoryFormComponentTW';
import CostUnitEnhancedTableTW from './CostUnitEnhancedTableTW';
import CostUnitFormComponentTW from './CostUnitFormComponentTW';


const styles = theme => ({
    margin: {
        margin: theme.spacing.unit,
    },
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commonData: [],
            openSubCategoryForm: false,
            openCostUnitForm: false,
        };
    }

    componentDidMount() {
        this.props.dispatch(commonActions.getAll('SubCategory'));
        this.props.dispatch(commonActions.getAll('CostUnit'));
        this.props.dispatch(departmentActions.getAll());
    }

    handleEditSubCategoryTable = (EditData) => {
        this.setState({
            commonData: EditData,
            openSubCategoryForm: true,
        })
    }

    handleEditCostUnitTable = (EditData) => {
        this.setState({
            commonData: EditData,
            openCostUnitForm: true,
        })
    }


    handleSubCategoryOpen = () => {
        this.setState({
            commonData: null,
            openSubCategoryForm: true
        })
    }

    handleCostUnitOpen = () => {
        this.setState({
            commonData: null,
            openCostUnitForm: true
        })
    }

    handleFormClose = () => {
        this.cleanData();
    }

    handleDeleteCommonTable = (DeleteData) => {
        const DataProcessing = async () => {
            try {
                await this.props.dispatch(commonActions.delete(DeleteData));
                await this.props.dispatch(commonActions.getAll('SubCategory'));
                await this.props.dispatch(commonActions.getAll('CostUnit'));
            } catch (e) {
                console.error("Problem", e)
            }
        }

        DataProcessing();
    }

    cleanData() {
        this.setState({
            commonData: null,
            openSubCategoryForm: false,
            openCostUnitForm: false
        });
    }

    render() {
        const { user } = this.props;
        return (
            <div>
                {
                    user.departmentLocate === 'TW' ?
                    <SubCategoryEnhancedTableTW
                        handleEditCommonTable={this.handleEditSubCategoryTable}
                        handleOpen={this.handleSubCategoryOpen}
                        handleDeleteClick={this.handleDeleteCommonTable}
                    /> :
                    <SubCategoryEnhancedTable
                        handleEditCommonTable={this.handleEditSubCategoryTable}
                        handleOpen={this.handleSubCategoryOpen}
                        handleDeleteClick={this.handleDeleteCommonTable}
                    />
                }

                {
                    user.departmentLocate === 'TW' ?
                    <SubCategoryFormComponentTW
                        open={this.state.openSubCategoryForm}
                        close={this.handleFormClose}
                        commonData={this.state.commonData}
                        selectedCommonType='SubCategory'
                    /> :
                    <SubCategoryFormComponent
                        open={this.state.openSubCategoryForm}
                        close={this.handleFormClose}
                        commonData={this.state.commonData}
                        selectedCommonType='SubCategory'
                    />
                }

                {
                    user.departmentLocate === 'TW' ?
                    <CostUnitEnhancedTableTW
                        handleEditCommonTable={this.handleEditCostUnitTable}
                        handleOpen={this.handleCostUnitOpen}
                        handleDeleteClick={this.handleDeleteCommonTable}
                    /> :
                    <CostUnitEnhancedTable
                        handleEditCommonTable={this.handleEditCostUnitTable}
                        handleOpen={this.handleCostUnitOpen}
                        handleDeleteClick={this.handleDeleteCommonTable}
                    />
                }

                {
                    user.departmentLocate === 'TW' ?
                    <CostUnitFormComponentTW
                        open={this.state.openCostUnitForm}
                        close={this.handleFormClose}
                        commonData={this.state.commonData}
                        selectedCommonType='CostUnit'
                    /> :
                    <CostUnitFormComponent
                    open={this.state.openCostUnitForm}
                    close={this.handleFormClose}
                    commonData={this.state.commonData}
                    selectedCommonType='CostUnit'
                    />
                }

            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { common } = state;

    return {
        user,
        common
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(App);


// WEBPACK FOOTER //
// ./src/components/Settings/App.js